import React from 'react';
import { Control, Controller } from 'react-hook-form';
import MultiSelect, { SelectOptionType } from '@/components/form/MultiSelect/MultiSelect';
import { ActionMeta } from 'react-select';

export interface MultiSelectControlledProps<T> {
  name: string;
  options: SelectOptionType[];
  control: Control;
  className?: string;
  error?: string;
  onSelect?: (option: T, actionMeta: ActionMeta<SelectOptionType>) => void;
}

function MultiSelectControlled<T>({ name, control, options, error, onSelect }: MultiSelectControlledProps<T>) {
  return (
    <Controller
      name={name}
      control={control}
      // @ts-expect-error Invalid
      render={({ field }) => <MultiSelect options={options} error={error} onSelect={onSelect} {...field} />}
    />
  );
}

export default MultiSelectControlled;
